namespace TabAurous.Retail {
    export namespace GiftVoucherSalesReceiptService {
        export const baseUrl = 'Retail/GiftVoucherSalesReceipt';

        export declare function Create(request: Serenity.SaveRequest<GiftVoucherSalesReceiptRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<GiftVoucherSalesReceiptRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<GiftVoucherSalesReceiptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<GiftVoucherSalesReceiptRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Retail/GiftVoucherSalesReceipt/Create",
            Update = "Retail/GiftVoucherSalesReceipt/Update",
            Delete = "Retail/GiftVoucherSalesReceipt/Delete",
            Retrieve = "Retail/GiftVoucherSalesReceipt/Retrieve",
            List = "Retail/GiftVoucherSalesReceipt/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>GiftVoucherSalesReceiptService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
